import {applyMiddleware, compose, legacy_createStore as createStore} from 'redux';
import rootReducer from './reducers';
import thunk from 'redux-thunk';
import {createLogger} from 'redux-logger'
import {persistReducer, persistStore} from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web

const logger = createLogger({
    duration: true,
    timestamp: true,
    diff: true,
    collapsed: true
});

const composeEnhancers =
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        }) : compose;

const enhancer = composeEnhancers(
    process.env.NODE_ENV !== 'production' ? applyMiddleware(logger) : applyMiddleware(thunk),
    // other store enhancers if any
);
const store = createStore(
    rootReducer,
    enhancer
);

const persistConfig = {
    key: 'root',
    storage,
    whitelist:['memorize']
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export default () => {
    let store = createStore(persistedReducer)
    let persistor = persistStore(store)
    return { store, persistor }
}
